import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailVerificationService } from '../../gen/api/emailVerification.service';
import { VerifyLoginEmailCredential } from '../../gen/model/verifyLoginEmailCredential';
import { Logger } from '../../util/logger';
import { AppConstants } from '../AppConstants';
import { LoginBaseComponent } from '../login-base.component';
import { ParamsService } from '../params.service';
import { AlertHandler } from '../no-concurrent-alerts-handler';
import { cardFooterFeedbackTransition } from '../animations';
import {animate, keyframes, query, style, transition, trigger} from '@angular/animations';
import {AuthenticationInfoService} from '../authentication-info.service';
import LocationUtil, {UrlParams, getAppBaseHref} from '../../util/locationUtil';
import {PlatformLocation} from '@angular/common';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';


const _ = (s) => s;

@Component({
  selector: 'app-validate-email',
  templateUrl: './validate-email.component.html',
  styleUrls: ['./validate-email.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    cardFooterFeedbackTransition,
    trigger('sendValidationFeedbackTransition', [
      transition(
        'void => *',
        [
          query(':self', [
            animate('200ms ease-in',
              keyframes([
                style({ transform: 'scaleY(0)' }),
                style({ transform: 'scaleY(1)' }),
              ])
            )
          ])
        ]
      ),
      transition(
        '* => void',
        [
          query(':self', [
            animate('200ms ease-in',
              keyframes([
                style({ transform: 'scaleY(1)' }),
                style({ transform: 'scaleY(0)' }),
              ])
            )
          ])
        ]
      ),
    ]),
  ],
})
export class ValidateEmailComponent extends LoginBaseComponent implements OnInit, OnDestroy {

  validationForm = new FormGroup({
    key: new FormControl('', [Validators.required]),
  });

  sendEmailForm = new FormGroup({
    email: new FormControl('', [Validators.email]),
  });

  key: string;
  email: string;
  emailsent: boolean;
  emailfailed: boolean;
  genericError: boolean;
  validationFailed: boolean;
  validationCodeExpired: boolean;
  hasSession: boolean;
  constructor(
    route: ActivatedRoute,
    router: Router,
    private authnInfoService: AuthenticationInfoService,
    @Inject('EmailVerificationApi') private emailVerificationApi: EmailVerificationService,
    private paramsService: ParamsService,
    private alertHandler: AlertHandler,
    private logger: Logger,
    private platformLocation: PlatformLocation,
    private translate: TranslateService,
    hostElement: ElementRef) {
    super(route, router, hostElement);
  }
  ngOnInit() {
    super.init();
    this.authnInfoService.startTask('validate_email');
    this.emailsent = false;
    this.emailfailed = false;
    this.validationFailed = false;
    this.genericError = false;
    this.validationCodeExpired = false;

    const tmp = this.authnInfoService.sessionInfo.getValue();
    if (tmp) {
      this.hasSession = tmp.hasSession;
      if (!tmp.hasSession && tmp.tasksInProgress.indexOf('validate_email') >= 0) {
        this.authnInfoService.cancelTask('validate_email');
      }
    }
    this.subscribeParamsState();
  }
  ngOnDestroy() {
    if (this.authnInfoService.sessionInfo.value.tasksInProgress.indexOf('validate_email') >= 0) {
      this.authnInfoService.cancelTask('validate_email');
    }
  }

  private subscribeParamsState() {
    const keyPromise = this.paramsService.getParam(AppConstants.QP_EMAIL_VALIDATION_KEY);
    const emailPromise = this.paramsService.getParam(AppConstants.QP_EMAIL);
    Promise.all([keyPromise, emailPromise]).then((values) => {
      const keyUrlParams = values[0];
      let key;
      if (keyUrlParams) {
        if (Array.isArray(keyUrlParams)) {
          key = keyUrlParams[0];
        } else {
          key = keyUrlParams;
        }
      }
      this.key = key;
      if (this.key) {
        this.validationForm.get('key').setValue(this.key);
      }
      const keyEmailParams = values[1];
      let email;
      if (keyEmailParams) {
        if (Array.isArray(keyEmailParams)) {
          email = keyEmailParams[0];
        } else {
          email = keyEmailParams;
        }
      }
      this.email = email;
      if (this.email) {
        this.sendEmailForm.get('email').setValue(this.email);
      }
      if (this.key && this.hasSession) {
        this.logger.debug('auto submitting valid form');
        this.submit();
      }
    });
    /*
    this.route.queryParams.subscribe(params => {
      const keyUrlParams = params[AppConstants.QP_EMAIL_VALIDATION_KEY];
      let key;
      if (keyUrlParams) {
        if (Array.isArray(keyUrlParams)) {
          key = keyUrlParams[0];
        } else {
          key = keyUrlParams;
        }
      }
      this.key = key;
      if (this.key) {
        this.validationForm.get('key').setValue(this.key);
      }
      const keyEmailParams = params[AppConstants.QP_EMAIL];
      let email;
      if (keyEmailParams) {
        if (Array.isArray(keyEmailParams)) {
          email = keyEmailParams[0];
        } else {
          email = keyEmailParams;
        }
      }
      this.email = email;
      if (this.email) {
        this.sendEmailForm.get('email').setValue(this.email);
      }
      if (this.key && this.hasSession) {
        this.logger.debug('auto submitting valid form');
        this.submit();
      }

    });
    */
  }

  submit() {
    const k = this.validationForm.get('key').value;
    this.validationCodeExpired = false;
    this.validationFailed = false;
    this.genericError = false;
    this.logger.debug('Submitted: %s', k);
    const verification: VerifyLoginEmailCredential = {
      authenticationMethod: AppConstants.AC_AM_VERIFY_EMAIL,
      verificationCode: k
    };
    this.authnInfoService.fetchAuthenticationInfo(undefined,(ainfo, sinfo) => {
      this.authnInfoService.addAuthentications([verification], false )
        .subscribe(response => {
          this.logger.debug('Validating email completed, response %d', response.status);
          this.authnInfoService.completeTask('validate_email');
        }, response => {
          this.logger.debug('Validating email failed, response %O', response);
          if (response && response.error === 'credentials_expired') {
            this.validationCodeExpired = true;
          }
          this.validationFailed = true;
          this.genericError = true;
        })
      ;
    });
  }

  sendEmail() {
    this.emailfailed = false;
    this.emailsent = false;
    const verificationUri = [];
    verificationUri.push(LocationUtil.getOwnDomainURL());
    verificationUri.push(getAppBaseHref(this.platformLocation));
    verificationUri.push(AppConstants.ROUTE_VALIDATE_EMAIL);
    if (verificationUri[0].indexOf('?') < 0) {
      verificationUri.push('?');
    } else {
      verificationUri.push('&');
    }
    verificationUri.push(AppConstants.QP_EMAIL_VALIDATION_KEY);
    verificationUri.push('={0}');
    const params: UrlParams = LocationUtil.getParams([AppConstants.QP_EMAIL_VALIDATION_KEY]);
    const keys = Object.keys(params);
    for (let i = 0; i < keys.length; i += 1) {
      verificationUri.push('&');
      verificationUri.push(keys[i]);
      verificationUri.push('=');
      verificationUri.push(params[keys[i]]);
    }
    this.emailVerificationApi.sendEmailVerification({ verificationUri: verificationUri.join('') }, 'response')
      .subscribe(response => {
        this.logger.debug('Sending email completed, response %d', response.status);
        this.emailsent = true;
      }, response => {
        this.logger.debug('Sending email  failed, response %O', response);
        this.emailfailed = true;
      })
    ;
  }

  signOut() {
    this.authnInfoService.cancelTask('validate_email');
    this.router.navigate([AppConstants.PATH_LOGOUT], {
      relativeTo: this.route,
    });
  }

  showSendEmailForm(): boolean {
    return !this.key || this.validationFailed;
  }

  hasError(field?: AbstractControl, code?: string): boolean {
    if (field && field === this.validationForm.get('key') && this.validationFailed && this.validationCodeExpired) {
      return true;
    } else {
      return this.genericError;
    }
  }

  isFieldInvalid(field: AbstractControl): boolean {
    return this.hasError(field) || this.isInputInvalid(field);
  }

  // noinspection JSMethodCanBeStatic
  isInputInvalid(field: AbstractControl): boolean {
    return field.invalid && field.touched;
  }

  isFieldValid(field: AbstractControl): boolean {
    return !this.hasError(field) && this.isInputValid(field);
  }

  // noinspection JSMethodCanBeStatic
  isInputValid(field: AbstractControl): boolean {
    return field.valid && field.touched;
  }
  public resolveWindowTitlePart(): Observable<string|undefined> {
    return this.translate.get('validate-email.window-title');
  }

}
